const alertInitialState = {
  alerts: [],
};

export default alertInitialState;